<div
  [formGroup]="widgetForm"
  #widgetBar
  [ngClass]="[
    canvasMode == 'view' &&
    widgetControls.controls &&
    widgetControls.controls.length <= 0
      ? 'widgetBarHidden'
      : 'widgetBar'
  ]"
>
  <div
    *ngIf="showWidgetBar()"
    class="wrapper"
    cdkDropList
    cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="drop($event)"
  >
    <div
      *ngFor="let item of widgetControls.controls; let i = index"
      cdkDrag
      style="display: inline-block"
      cdkDragBoundary=".wrapper"
      [cdkDragDisabled]="!hasEdit || height > 60"
    >
      <div class="container">
        <div
          class="item"
          [ngClass]="{
            multi: item.get('itemArray').value.length > 1
          }"
        >
          <fa-icon
            [icon]="faGripDotsVertical"
            class="grip"
            [ngClass]="{
              view: !hasEdit
            }"
            cdkDragHandle
          ></fa-icon>
          <div
            class="title"
            *ngIf="item.get('itemArray').value.length <= 1"
            [ngClass]="{
              locked: !hasEdit
            }"
            [matTooltip]="item.get('description').value"
            (click)="!hasEdit && gotoLink(item.get('itemArray').value[0])"
            (click)="hasEdit && openDetailDialog(item, i)"
          >
            {{ item.get("title").value }}
          </div>

          <div
            class="title"
            *ngIf="!hasEdit && item.get('itemArray').value.length > 1"
            [matMenuTriggerFor]="menu"
            (click)="openmenu(item)"
          >
            {{ item.get("buttonTitle").value }}
          </div>
          <div
            class="title"
            *ngIf="hasEdit && item.get('itemArray').value.length > 1"
            (click)="openDetailDialog(item, i)"
          >
            {{ item.get("buttonTitle").value }}
          </div>

          <div class="icons" *ngIf="hasEdit">
            <fa-icon [icon]="faTrash" (click)="deleteItem(i)"></fa-icon>
          </div>
          <div
            class="icons"
            *ngIf="!hasEdit && item.get('itemArray').value.length > 1"
            [matMenuTriggerFor]="menu"
            (click)="openmenu(item)"
          >
            <fa-icon [icon]="faCaretDown" style="font-size: medium"></fa-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="addContainer"
    *ngIf="hasEdit && widgetControls.controls.length <= 7"
  >
    <fa-stack
      id="addwidget"
      class="addObject"
      (click)="openWidgetDialog()"
      matTooltip="Create Widget"
      matTooltipPosition="right"
    >
      <fa-icon [icon]="faCircleDashed" stackItemSize="2x"></fa-icon>
      <fa-icon [icon]="faPlus" [inverse]="true" stackItemSize="1x"></fa-icon>
    </fa-stack>
    <span class="addObjectText"
      ><span *ngIf="widgetControls.controls.length <= 0">ADD WIDGET</span></span
    >
  </div>
  <div
    class="helpContainer"
    *ngIf="hasEdit && widgetControls.controls.length >= 0"
  >
    <span class="objectHelpText"></span>
  </div>

  <mat-menu #menu="matMenu" class="widgetDropdown">
    <ng-container *ngFor="let item of widgetItems; let i = index">
      <ng-container *ngIf="item.type == 'section'">
        <span class="section">
          {{ item.title }}
        </span>
      </ng-container>
      <ng-container *ngIf="item.type != 'section'">
        <span
          (click)="gotoLink(item)"
          [ngClass]="[
            i > 0 && widgetItems[i - 1].type != 'section'
              ? 'row'
              : 'row-noborder'
          ]"
        >
          {{ item.title }}
          <ng-container *ngIf="item.description">
            <fa-icon
              [icon]="faQuestionCircle"
              matTooltip="{{ item.description }}"
              matTooltipPosition="right"
              matTooltipClass="widget-tooltip"
            ></fa-icon>
          </ng-container>
        </span>
      </ng-container>
    </ng-container>
  </mat-menu>
</div>
